import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import {
    InputGroup, Input, InputGroupText,
    Label, Row, Col, Button,
    Card, CardHeader, CardBody,
    CardFooter, CardTitle, CardText
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { StudentsSearch, UsersSearch } from '../../../components';

import './AdminDashboard.css';
import { loadGroups, loadTeachers, loadStudents, loadUsers } from '../../../redux';
import Icon from '@mdi/react';
import { mdiEyeArrowRightOutline, mdiAccountArrowRightOutline, mdiAccountSearchOutline, mdiClose } from '@mdi/js';

const Dashboard = props => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const { groups }    = useSelector(state => state.groups);
    const { students }  = useSelector(state => state.students);
    const { teachers }  = useSelector(state => state.teachers);
    const { users }     = useSelector(state => state.users);

    useEffect(() => {
        dispatch(loadGroups());
        dispatch(loadUsers());
        dispatch(loadStudents());
        dispatch(loadTeachers());
    }, [])

    return (
        <div className="AdminDashboard">
            <Row className="mb-0" >
                <Col>
                    <Card>
                        <CardHeader color="light">
                            <CardTitle tag="h3">
                                { t('dashboard.current_workforce') }
                            </CardTitle>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md={4} className="mb-3" >
                                    <Card color="light" className="text-dark h-100">
                                        <CardBody className="d-flex align-items-center">
                                            <CardTitle tag="h1" className="align-items-center">
                                                <strong>
                                                    { groups?.length }&nbsp;
                                                </strong>
                                                <small>
                                                    { t('dashboard.total_groups') }
                                                </small>
                                            </CardTitle>
                                        </CardBody>
                                        <CardFooter>
                                            <CardText>
                                                <Button tag={Link} color="primary" to="/groups/list" className="text-light" block>
                                                    <Icon path={mdiEyeArrowRightOutline} size={1} />&nbsp;
                                                    {t('dashboard.see_groups')}
                                                </Button>
                                            </CardText>
                                        </CardFooter>
                                    </Card>
                                </Col>
                                <Col md={4} className="mb-3" >
                                    <Card color="light" className="text-dark h-100">
                                        <CardBody className="d-flex align-items-center">
                                            <CardTitle tag="h1" className="align-items-center">
                                                <strong>
                                                    { students?.length }&nbsp;
                                                </strong>
                                                <small>
                                                    { t('dashboard.total_students') }
                                                </small>
                                            </CardTitle>
                                        </CardBody>
                                        <CardFooter>
                                            <CardText>
                                                <Button tag={Link} color="primary" to="/students/list" className="text-light" block>
                                                    <Icon path={mdiEyeArrowRightOutline} size={1} />&nbsp;
                                                    {t('dashboard.see_students')}
                                                </Button>
                                            </CardText>
                                        </CardFooter>
                                    </Card>
                                </Col>
                                <Col md={4} className="mb-3" >
                                    <Card color="light" className="text-dark h-100">
                                        <CardBody className="d-flex align-items-center">
                                            <CardTitle tag="h1" className="align-items-center">
                                                <strong>
                                                    { teachers?.length }&nbsp;
                                                </strong>
                                                <small>
                                                    { t('dashboard.total_teachers') }
                                                </small>
                                            </CardTitle>
                                        </CardBody>
                                        <CardFooter>
                                            <CardText>
                                                <Button tag={Link} color="primary" to="/teachers/list" className="text-light" block>
                                                    <Icon path={mdiEyeArrowRightOutline} size={1} />&nbsp;
                                                    {t('dashboard.see_teachers')}
                                                </Button>
                                            </CardText>
                                        </CardFooter>
                                    </Card>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Row className="row-flex justify-content-md-start mt-3">
                        <Col lg={6} className="mb-3" >
                            <StudentsSearch students={students} />
                        </Col>
                        <Col lg={6} className="mb-3" >
                            <UsersSearch users={users} />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}

export default Dashboard;
